import { useFormContext } from "react-hook-form";
import CField from "$forms/CField";
import { Text } from "$components";
import useCompany from "$hooks/useCompany";
import useJStyles from "$hooks/useJStyles";
import ActivitiesCheckboxes from "$forms/ActivitiesCheckboxes";
import { Company, CompanyType } from "$types";
import useActivities from "../hooks/useActivities";

export type ActivitiesProps = {
  companyTypes: CompanyType[];
  relatedCarrierId: string;
  defaultValues: Partial<Company>;
  companies: Company[];
};

export default function Activities({
  companyTypes,
  relatedCarrierId,
  defaultValues,
  companies,
}: ActivitiesProps) {
  const { jclasses } = useJStyles();
  const { isAgency, isCarrier, isLogistician } = useCompany();

  const {
    relatedCarrierActivities,
    logisticianActivities,
    usedCarrierActivities,
    getRelevantActivities,
  } = useActivities({
    companyTypes,
    relatedCarrierId,
    defaultValues,
    companies,
  });

  const {
    control,
    formState: { errors },
  } = useFormContext();

  // Only render if company type requires activities
  if (
    !isCarrier(companyTypes) &&
    !(isAgency(companyTypes) && relatedCarrierActivities.length > 0) &&
    !(isLogistician(companyTypes) && logisticianActivities.length > 0)
  ) {
    return null;
  }

  return (
    <>
      <div className={jclasses.formSectionHead}>
        <Text type="h3">Activité(s)</Text>
      </div>
      <CField
        control={control}
        label="Activité(s)"
        name="activities"
        rules={{
          required: "Veuillez sélectionner au moins une activité",
        }}
        error={errors.activities}
      >
        {(props: any) => (
          // @todo: can make a single multi checkbox component for activites and company types
          <ActivitiesCheckboxes
            activities={getRelevantActivities()}
            disabledActivities={usedCarrierActivities}
            disabledMessage={
              isCarrier(companyTypes) &&
              "Une agence transporteur rattachée effectue cette activité."
            }
            value={props.value}
            onChange={props.onChange}
          />
        )}
      </CField>
    </>
  );
}
